export default function formatDataUrlWithUrl (dataUrl: string, url: string) {
  const fileType = url.split('.').pop();
  const allowedImageTypes = ['jpeg', 'jpg', 'png']; // Could add svg and webp in the future
  let mimeType = 'application/octet-stream';
  if (allowedImageTypes.indexOf(fileType) > -1) {
    // According to MDN, both .jpeg and .jpg use image/jpeg
    mimeType = 'image/jpeg';
    if (fileType !== 'jpg') {
      mimeType = `image/${fileType}`;
    }
  } else if (fileType === 'pdf') {
    mimeType = 'application/pdf';
  }
  return `data:${mimeType};base64,${dataUrl}`;
}
